import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import AccountActions from './account/account_actions.js';
import { i18n, isAuth, domain, domainVal, opt } from 'arm-common';
import { AppConstants } from '../constants/AppConstants';

import AppActions from '../app/app_actions'
import BaseActions from '../app/_base_actions';


class MenuTop extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MenuTop.jsx] ';
        this.logoutOnClick = this.logoutOnClick.bind(this);
    }


    logoutOnClick() {
        console.log(this.componentName + 'logoutOnClick');
        this.props.logoutOnClick();
    }


    render() {
        console.log(this.componentName + 'render');

        if (this.props.utente === undefined || this.props.utente === null || this.props.utente.userId === null) {
            return null;
        }

        let elencoRuoliString = '';
        let arrayRuoli = this.props.utente.roles;
        if (arrayRuoli !== undefined && arrayRuoli !== null) {
            for (let i = 0; i < arrayRuoli.length; i++) {
                let currRuolo = arrayRuoli[i];
                if (elencoRuoliString !== '') {
                    elencoRuoliString = elencoRuoliString + ', ';
                }
                elencoRuoliString = elencoRuoliString + currRuolo;
            }
        }

        return (



            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <a className="navbar-brand mt-3" href="#/home">HOME</a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                    <ul className="navbar-nav">


                        {isAuth('V2.ADMIN.PRODUCT.VIEW.FAMIGLIE') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/famiglie/list">{i18n('ARM_CORE_PRODUCT.MENUTOP.PRODOTTI_FAMIGLIE', 'Famiglie Prodotto')}</a>
                            </li>
                            : null

                        }
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.CATEGORIE') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/categorie/list">{i18n('ARM_CORE_PRODUCT.MENUTOP.CATEGORIE', 'Categorie Prodotto')}</a>
                            </li>
                            : null}



                        {isAuth('V2.ADMIN.PRODUCT.VIEW.MICRO-CATEGORIE') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/microCategorie/list">{i18n('ARM_CORE_PRODUCT.MENUTOP.MICROCATEGORIE', 'Micro-categorie')}</a>
                            </li>
                            : null
                        }
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTI') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/prodotto/listOrigine">{i18n('ARM_CORE_PRODUCT.MENUTOP.PRODOTTI', 'Prodotti')}</a>
                            </li>
                            : null
                        }

                        {/* 
                        {isAuth('PRODUCT_VERS_PRODOTTO') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/prodotto/list">{i18n('ARM_CORE_PRODUCT.MENUTOP.VERSIONIPRODOTTI', 'Versioni Prodotto')}</a>
                            </li>
                            : null
                        } */}




                        {/* {isAuth('V2.ADMIN.PRODUCT.VIEW.FAMIGLIE') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/prodotto/prodottoFamiglie">{i18n('ARM_CORE_PRODUCT.MENUTOP.PRODOTTI_FAMIGLIE', 'Famiglie Prodotto')}</a>
                            </li>
                            : null
                        } */}

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.GARANZIE') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/garanzie/list">{i18n('ARM_CORE_PRODUCT.MENUTOP.GARANZIE', 'Garanzie')}</a>
                            </li>
                            : null
                        }

                        {isAuth('V2.ADMIN.PRODUCT.VIEW.COMPAGNIE') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/compagnie/list">{i18n('ARM_CORE_PRODUCT.MENUTOP.COMPAGNIE', 'Compagnie')}</a>
                            </li>
                            : null
                        }

                        {/* {isAuth('PRODUCT_BISOGNI') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/bisogni/list">{i18n('ARM_CORE_PRODUCT.MENUTOP.BISOGNI', 'Bisogni')}</a>
                            </li>
                            : null
                        } */}

                        {/* {opt("APP", "FLAG_FINANCE", "false") === "TRUE" && */}
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.FONDI') ?
                            <li className="nav-item">
                                <a className="nav-link" href="#/fondi/list">{i18n('ARM_CORE_PRODUCT.MENUTOP.FONDI', 'Fondi')}</a>
                            </li>
                            : null
                        }

                        <li className="nav-item">
                            <a className="nav-link" href="#/impostazioni"><i className="fas fa-cogs fa-fw" />{i18n('ARM_CORE_PRODUCT.MENUTOP.IMPOSTAZIONI', 'Impostazioni')}</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" href="#/account/manage" title={elencoRuoliString}><i className="fas fa-user fa-fw" />{this.props.utente.userId}</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" href="#/logout"> <i className="fas fa-sign-out-alt fa-fw" />{i18n('ARM_CORE_PRODUCT.MENUTOP.LOGOUT', 'Log Out')}</a>
                        </li>

                        <li className="nav-item" style={{marginTop: "7px"}}>
                            <i className="fas fa-info-circle" style={{fontSize:"9px",color:"rgba(0,0,0,.5)"}} title={"JAVA-VERSION : " + this.props.version +"\r\n"+"ARM-CORE-PRODUCT : " + AppConstants.VERSIONE}/>
                        </li>


                    </ul>
                </div>
            </nav>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        // logoutOnClick: function logoutOnClick() {
        //     return dispatch(AccountActions.logout());
        // },
        getVersione() {
            return dispatch(AccountActions.getVersione());
        }
    }
};

function mapStateToProps(state) {
    return {
        utente: state.account.utente,
        i18nlabels:state.app.i18nlabels,
        locate: state.app.locate,
        version: state.account.version
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MenuTop));
